import gql from 'graphql-tag';

import embeddedDokkioTagFragment from './embeddedDokkioTagFragment';

export const dokkioObjectDokkioTagFragment = gql`
  fragment dokkioObjectDokkioTagFragment on DokkioObjectDokkioTag {
    dokkioClass
    id
    accountID
    dokkioObjectID
    dokkioTagID
    dokkioTag {
      ...embeddedDokkioTagFragment
    }
    rowCreateMethod
  }
  ${embeddedDokkioTagFragment}
`;

export default dokkioObjectDokkioTagFragment;
